import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Motion";

const FAQS = [
  { q: "Do I need any experience with yoga, meditation or the koshas?", a: "No. The journey is designed for newcomers. Each layer is introduced in everyday language, and every practice starts from the beginning." },
  { q: "What if I miss a day?", a: "That's fine. You can pick up where you left off. The journey is meant to support you, not to become another thing to keep up with." },
  { q: "What does Panchmaya coaching focus on?", a: "Our coaching supports self-exploration, practical habit change, clarity, active living, and personal development. For concerns outside the scope of coaching, seek support from an appropriately licensed professional." },
  { q: "When does the next journey begin?", a: "The 21-day coaching journey is coming soon. Get in touch with us, and we'll get back to you with the next available opportunity to join. Private 1:1 coaching with Sheetal is available now." },
];

export const Faq = () => (
  <section className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 md:py-32 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-12" data-testid="faq-section">
    <SectionHead size="large" eyebrow="Common questions" title="Before you begin" />
    <Reveal delay={0.1}>
      <Accordion type="single" collapsible className="border-t border-[#e4dacb]">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="border-[#e4dacb]">
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-6 text-lg font-medium leading-snug text-[#221e1b] hover:no-underline sm:text-xl">
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${i + 1}`} className="max-w-2xl pb-6 text-[1.0625rem] leading-[1.75] text-[#5d544c] sm:text-lg">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
